module.exports = __webpack_public_path__ + "img/cwgk.6279366d.png";